(() => {
  const forms = document.querySelectorAll('[data-ots-review-form]');
  if (!forms.length) return;

  const readFile = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result));
    reader.onerror = () => reject(new Error('Could not read the selected photo.'));
    reader.readAsDataURL(file);
  });

  const request = async (path, payload) => {
    const response = await fetch(path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
    const result = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(result.error || `Request failed (${response.status}).`);
    return result;
  };

  const updateRating = (form) => {
    const selected = Number(form.querySelector('input[name="rating"]:checked')?.value || 0);
    form.querySelectorAll('[data-rating-star]').forEach((star) => {
      star.classList.toggle('is-selected', Number(star.dataset.ratingStar) <= selected);
    });
    const label = form.querySelector('[data-ots-rating-label]');
    if (label) label.textContent = selected ? `${selected} / 5` : 'Not selected';
  };

  forms.forEach((form) => {
    const submitButton = form.querySelector('[data-ots-review-submit]');
    const feedback = form.querySelector('[data-ots-review-feedback]');
    const fileInput = form.querySelector('[data-ots-review-file]');
    const fileName = form.querySelector('[data-ots-review-file-name]');
    if (!submitButton || !feedback || !fileInput) return;

    submitButton.disabled = false;
    form.addEventListener('change', (event) => {
      if (event.target.name === 'rating') updateRating(form);
      if (event.target === fileInput && fileName) {
        fileName.textContent = fileInput.files?.[0]?.name || 'JPG, PNG or WebP up to 10 MB';
      }
    });
    form.addEventListener('reset', () => {
      window.setTimeout(() => {
        updateRating(form);
        if (fileName) fileName.textContent = 'JPG, PNG or WebP up to 10 MB';
      }, 0);
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!form.reportValidity()) return;

      submitButton.disabled = true;
      submitButton.textContent = 'Submitting...';
      form.setAttribute('aria-busy', 'true');
      feedback.textContent = '';
      feedback.classList.remove('is-error', 'is-success');

      try {
        const file = fileInput.files?.[0];
        let mediaUrls = [];
        if (file) {
          if (file.size > 10 * 1024 * 1024) throw new Error('Photo must be 10 MB or smaller.');
          if (!['image/png', 'image/jpeg', 'image/webp'].includes(file.type)) {
            throw new Error('Photo must be a JPG, PNG, or WebP image.');
          }
          const upload = await request('/apps/reviews/api/public/uploads', {
            fileName: file.name,
            dataUrl: await readFile(file)
          });
          if (!upload.url) throw new Error('Photo upload did not finish. Please try again.');
          mediaUrls = [upload.url];
        }

        const fields = new FormData(form);
        await request('/apps/reviews/api/public/reviews', {
          productId: 'sitewide',
          productTitle: 'Store experience',
          orderId: String(fields.get('orderId') || '').trim(),
          rating: Number(fields.get('rating')),
          title: String(fields.get('title') || '').trim(),
          body: String(fields.get('body') || '').trim(),
          reviewerName: String(fields.get('reviewerName') || '').trim(),
          reviewerEmail: String(fields.get('reviewerEmail') || '').trim(),
          website: String(fields.get('website') || '').trim(),
          mediaUrls
        });

        form.reset();
        feedback.textContent = 'Thank you. Your review was submitted for moderation.';
        feedback.classList.add('is-success');
      } catch (error) {
        feedback.textContent = error instanceof Error ? error.message : 'Could not submit your review. Please try again.';
        feedback.classList.add('is-error');
      } finally {
        submitButton.disabled = false;
        submitButton.textContent = 'Submit for moderation';
        form.removeAttribute('aria-busy');
      }
    });
  });

  const openButton = document.querySelector('[data-ots-review-open]');
  const dialog = document.querySelector('[data-ots-review-dialog]');
  if (openButton && dialog) {
    const updatePreviewBarOffset = () => {
      const bar = document.getElementById('PBarNextFrameWrapper');
      const rect = bar?.getBoundingClientRect();
      const offset = rect && rect.height > 0 && rect.bottom >= window.innerHeight - 2
        ? Math.ceil(rect.height) : 0;
      document.documentElement.style.setProperty('--ots-review-preview-bar-offset', `${offset}px`);
    };
    const resizeObserver = new ResizeObserver(updatePreviewBarOffset);
    const watchPreviewBar = () => {
      const bar = document.getElementById('PBarNextFrameWrapper');
      if (bar) {
        resizeObserver.observe(bar);
        mutationObserver.disconnect();
      }
      updatePreviewBarOffset();
    };
    const mutationObserver = new MutationObserver(watchPreviewBar);
    mutationObserver.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', updatePreviewBarOffset);
    watchPreviewBar();
    openButton.addEventListener('click', () => {
      dialog.showModal();
      dialog.querySelector('#ots-review-mobile-heading')?.focus({ preventScroll: true });
    });
    dialog.querySelector('[data-ots-review-close]')?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', () => openButton.focus());
  }
})();
